// @ts-nocheck
import { useEffect, useState } from "react";
import { db } from "../db/db";
import { API_BASE_URL as BACKEND } from "../utils/api";

function DataRetrieve(id: any) {
  const [visits, setVisits] = useState([]);
  const [carePlans, setCarePlans] = useState([]);
  const [allocatedShifts, setAllocatedShifts] = useState([]);
  const [contractedShifts, setContractedShifts] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [usernames, setUsernames] = useState([]);
  const [holidayList, setHolidayList] = useState([]);
  const [holidayStatus, setHolidayStatus] = useState([]);
  const [clients, setClients] = useState([]);

  useEffect(() => {
    //   const id = auth['id']
    if (id) {
      const userId = id["id"];
      const userIdAsString = String(userId ?? "");

      if (!userIdAsString || userIdAsString.length >= 5) {
        return;
      }
      fetch(`${BACKEND}/visits?id=${userId}`)
        .then((response) => response.json())
        .then((result) => setVisits(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/shifts/allocated?id=${userId}`)
        .then((response) => response.json())
        .then((result) => setAllocatedShifts(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/shifts/contracted?id=${userId}`)
        .then((response) => response.json())
        .then((result) => setContractedShifts(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/care-plan`)
        .then((response) => response.json())
        .then((result) => setCarePlans(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/tasks`)
        .then((response) => response.json())
        .then((result) => setTasks(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/usernames`)
        .then((response) => response.json())
        .then((result) => setUsernames(result));
      fetch(`${BACKEND}/holiday/list?id=${userId}`)
        .then((response) => response.json())
        .then((result) => setHolidayList(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/holiday?id=${userId}`)
        .then((response) => response.json())
        .then((result) => setHolidayStatus(result))
        .catch((error) => console.error(error));
      fetch(`${BACKEND}/clients?id=${userId}`)
        .then((response) => response.json())
        .then((result) => setClients(result))
        .catch((error) => console.error(error));
    }
  }, [id]);

  useEffect(() => {
    if (visits) {
      if (visits.length !== 0) {
        db.visits.clear();
        db.visits.bulkAdd(visits);
        try {
        } catch (error) {
          console.log(error);
        }
      }
    }
  }, [visits]);

  useEffect(() => {
    if (usernames) {
      db.users.clear();
      db.users.bulkAdd(usernames);
    }
  }, [usernames]);

  useEffect(() => {
    if (carePlans) {
      if (carePlans.length !== 0) {
        db.carePlans.clear();
        db.carePlans.bulkAdd(carePlans);
        try {
        } catch (error) {
          console.log(error);
        }
      }
    }
  }, [carePlans]);

  useEffect(() => {
    if (allocatedShifts) {
      if (allocatedShifts.length !== 0) {
        db.allocatedShifts.clear();
        db.allocatedShifts.bulkAdd(allocatedShifts);
        try {
        } catch (error) {
          console.log(error);
        }
      }
    }
  }, [allocatedShifts]);

  useEffect(() => {
    if (contractedShifts) {
      if (contractedShifts.length !== 0) {
        db.contractedShifts.clear();
        db.contractedShifts.bulkAdd(contractedShifts);
        try {
        } catch (error) {
          console.log(error);
        }
      }
    }
  }, [contractedShifts]);
  useEffect(() => {
    if (tasks) {
      if (tasks.length !== 0) {
        db.tasks.clear();
        db.tasks.bulkAdd(tasks);
        try {
        } catch (error) {
          console.log(error);
        }
      }
    }
  }, [tasks]);

  useEffect(() => {
    if (holidayList) {
      if (holidayList.length !== 0) {
        db.holiday_list.clear();
        db.holiday_list.bulkAdd(holidayList);
      }
    }
  }, [holidayList]);

  useEffect(() => {
    if (holidayStatus) {
      if (holidayStatus.length !== 0) {
        const data = { id: holidayStatus[0].id, status: holidayStatus };
        // db.holiday_status.clear();
        db.holiday_status.add(data, [holidayStatus[0].id]);
      }
    }
  }, [holidayStatus]);

  useEffect(() => {
    if (clients) {
      if (clients.length !== 0) {
        db.clients.clear()
        const correctedClients = clients.map((client) => {
          return {
            idc1_staff: client["idc1_staff"],
            ida1_client: client["ida1_client"],
            name: client["name"]
          };
        });
        db.clients.bulkAdd(correctedClients)
      }
    }
  }, [clients]);

  return <></>;
}
export default DataRetrieve;
